export const BACKEND_URL = "global.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "aae6f6aeeb4f04889760a7feaa1b67fb027f414446cee95b5245bbffd46688199eb839cf07987761c64081068d993b470c50e56d0a6913715015dc235f0009b9ec7a90bd640a9052025b8666761325e2d83e065be56f46057bea62174417c52c";
export const LOCATIONS: [[number, number], string][] = [
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"]
];